import { navItem } from "@touchworks/shared/platform/navigation.js";
import { spotlightTarget } from "@touchworks/shared/platform/spotlightTargets.js";

/**
 * Traduz o destino que a API devolve no `try` para onde o navegador vai.
 *
 *   nav   a funcionalidade âncora (ou o recurso, quando a novidade tem um): a rota
 *         vem do catálogo do menu / do registro de alvos, sob a conta da sessão
 *   path  caminho interno digitado no admin, relativo à conta ("/crm?tab=x");
 *         um caminho que já começa em "/internal/" é da plataforma e fica como está
 *   url   link externo https, aberto em outra aba
 *
 * É função pura de propósito: quem sabe montar o prefixo da conta é o layout
 * (`resolveAccountPath`), e este arquivo não importa nem contexto nem roteador.
 *
 * @param {{ kind: string, value?: string|null, anchorNavKey?: string, targetKey?: string|null }} destination
 * @param {(subPath: string) => string} resolveAccountPath
 * @returns {{ type: "internal", to: string } | { type: "external", url: string } | null}
 */
export function resolveDestination(destination, resolveAccountPath) {
  if (!destination) return null;
  const { kind, value, anchorNavKey, targetKey } = destination;

  if (kind === "url") {
    return value ? { type: "external", url: value } : null;
  }

  if (kind === "path") {
    if (!value) return null;
    return { type: "internal", to: value.startsWith("/internal/") ? value : resolveAccountPath(value) };
  }

  if (kind === "nav") {
    const target = targetKey ? spotlightTarget(targetKey) : null;
    if (target) {
      const subPath = `${target.path}${target.query ? `?${target.query}` : ""}`;
      // Um recurso de uma tela "flat" (Indique e Ganhe) mora fora de `implementation/:clientId`.
      const owner = navItem(target.navKey);
      return { type: "internal", to: owner?.flat ? `/internal${subPath}` : resolveAccountPath(subPath) };
    }
    const item = anchorNavKey ? navItem(anchorNavKey) : null;
    if (!item) return null;
    return { type: "internal", to: item.flat ? `/internal${item.path}` : resolveAccountPath(item.path) };
  }

  return null;
}
